// Type imported from its own module rather than the feature barrel, as `import type` — the barrel
// pulls the Apollo client on load, which breaks any test that imports this module (see the same
// note in ValidateBuildingProjectService.ts).
import type { ReferencedAreasType } from "../types/ReferencedAreasType";

/**
 * Strip reference-area entries that never picked a structure type before the project is sent to
 * the API.
 *
 * The wizard deliberately keeps incomplete rows (area typed, structure still on "Select") in the
 * project state: that is what lets them survive step navigation and lets `validateReferenceArea`
 * refuse the create wizard's Next instead of the row silently vanishing. The API contract has no
 * notion of a type-less entry, so every payload builder that sends `referencedAreas` must pass it
 * through here. Entries with a type but a null area are NOT stripped — the API accepted those
 * before this state existed, and existing projects hold them.
 */
export const withoutIncompleteReferenceAreaEntries = (referencedAreas: ReferencedAreasType): ReferencedAreasType => ({
  ...referencedAreas,
  entries: referencedAreas.entries?.filter((entry) => entry.type !== ""),
});
